export const FETCH_SIMS = 'FETCH_SIMS';
export const FETCH_SIMS_COUNT = 'FETCH_SIMS_COUNT';
export const ADD_SIMS_SUCCESS = 'ADD_SIMS_SUCCESS';
export const FETCH_SIMS_CARRIERS = 'FETCH_SIMS_CARRIERS';
